<template>
  <div class="results-container">
    <p class="text-center grey--text">Attributes</p>
    <div class="results-container__top">
      <v-chip
        v-for="attr in attributes"
        :key="attr.title"
        class="ma-1"
        :class="attr.color"
      >
        {{ attr.title }}
      </v-chip>
    </div>
    <div class="results-container__middle">
      <div>
        <p class="text-center grey--text">Brand statement</p>
        <h1 v-text="phrase" class="text-center display-2"></h1>
      </div>
    </div>
    <div class="d-flex flex-row justify-space-between align-center mb-10">
      <div></div>
      <p class="text-center grey--text ma-0 pa-0">Benefits</p>
      <div>
        <v-btn @click="expand()" class="white mr-2" small light>{{
          expandLabel
        }}</v-btn>
        <v-btn @click="add" class="white" fab small light>
          <v-icon>mdi-plus</v-icon></v-btn
        >
      </div>
    </div>

    <div class="results-container__bottom">
      <v-row class="">
        <v-col
          v-for="col in flattenedBenefits"
          :key="col.title"
          class="unit mb-4"
          cols="2"
        >
          <p class="results-container__bottom__header">
            {{ col.title }}
          </p>
          <v-card
            v-for="(row, index) in col.items"
            :key="`${col.title}-${index}`"
            class="unit__card mb-5"
          >
            <benefits-card
              :item="row"
              :index="row.index"
              mode="compact"
              :attributes="attributes"
              :override="override"
              @edit="edit"
              @remove="remove"
            />
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div class="break">
      <p class="text-center grey--text ma-0 pa-0">
        All
      </p>
      <div
        class="d-flex flex-row justify-space-between results-container__bottom"
      >
        <v-row>
          <v-col
            v-for="(row, index) in all"
            :key="`solo-${index}`"
            cols="2"
            class="unit"
          >
            <v-card class="unit__card mb-5">
              <benefits-card
                :item="row"
                :index="row.index"
                mode="compact"
                :attributes="attributes"
                @edit="edit"
                @remove="remove"
              />
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>

    <v-dialog v-model="dialog" max-width="800">
      <v-card v-if="deleteMode" light>
        <v-card-title>
          Are you sure you want to delete this item? {{ deleteId }}
        </v-card-title>
        <v-card-text class="">
          <v-btn light color="amber mr-5" class="" @click="removeItem"
            >Delete</v-btn
          >

          <v-btn light color="white" class="" @click="cancel">Cancel</v-btn>
        </v-card-text>
      </v-card>
      <v-card light v-else-if="editMode">
        <embed-form
          v-model="item"
          title="Edit an item"
          :showAudience="true"
          :attributes="attributes"
          :dropdown="dropdown"
        >
          <v-btn light color="green" class="mt-10 mr-2" @click="editItem"
            >Update</v-btn
          >
          <v-btn light color="white" class="mt-10 mr-2" @click="cancel"
            >Cancel</v-btn
          >
        </embed-form>
      </v-card>
      <v-card light v-else>
        <v-card-text class="">
          <embed-form
            v-model="item"
            title="Add an item"
            :showAudience="true"
            :attributes="attributes"
            :dropdown="dropdown"
          >
            <v-btn light color="green" class="mt-10 mt-2 mr-2" @click="addItem"
              >Create Attribute</v-btn
            >
            <v-btn light color="white" class="mt-10 mt-2 mr-2" @click="cancel"
              >Cancel</v-btn
            >
          </embed-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import BenefitsCard from "@/views/user/exercises/attributes/BenefitsCard";
import BenefitsMixin from "@/views/user/exercises/attributes/BenefitsMixin";
import EmbedForm from "@/views/user/exercises/attributes/EmbedForm";

export default {
  name: "BenefitsResults",
  data() {
    return {
      refs: null,
      override: false,
    };
  },

  mixins: [BenefitsMixin],

  components: {
    BenefitsCard,
    EmbedForm,
  },

  watch: {
    value: {
      handler: function(val) {
        this.items = val;
      },
      deep: true,
    },
  },

  props: {
    attributes: {
      type: Array,
      default: () => [],
    },
    phrase: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    dropdown: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    flattenedBenefits() {
      if (this.items && this.dropdown) {
        let arr = [];
        const cats = this.dropdown;
        cats.forEach((x) => {
          arr.push({
            title: x.title,
            items: this.items.filter((y) =>
              y.audience.some((z) => z === x.title)
            ),
          });
        });
        return arr;
      } else {
        return [];
      }
    },
    all() {
      // return this.items.filter((x) => x.includes((y) => y.title == x.title));
      return this.items;
    },
    expandLabel() {
      return this.override ? "Compact" : "Expand cards";
    },
  },

  methods: {
    expand() {
      this.override = !this.override;
    },
  },
};
</script>

<style scoped>
.break {
  display: block;
  margin-top: 250px;
}
</style>
